module.exports = __webpack_public_path__ + "img/meal-input-ja.f29ea083.png";